import { ParcelTrackingNumber } from '../../ParcelTrackingNumber/ParcelTrackingNumber.js';
import { getTrackingNumberAsideStyles, getParcelTrackingNumberStyles } from './TrackingNumberAsideStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

function TrackingNumberAside(_ref) {
  let {
    carrierTrackingNumber,
    trackingUrl,
    ...otherProps
  } = _ref;
  return jsx("aside", {
    css: getTrackingNumberAsideStyles,
    ...otherProps,
    children: jsx(ParcelTrackingNumber, {
      css: getParcelTrackingNumberStyles,
      trackingNumber: carrierTrackingNumber,
      trackingUrl: trackingUrl
    })
  });
}

export { TrackingNumberAside };
//# sourceMappingURL=TrackingNumberAside.js.map
